import { Helmet } from 'react-helmet-async';

import type { JsonLdObject } from '../lib/jsonLd';

/** Injects one or more JSON-LD blocks into the head. Null entries are skipped. */
export function JsonLd({ data }: { data: (JsonLdObject | null)[] }) {
  const blocks = data.filter(Boolean) as JsonLdObject[];
  if (blocks.length === 0) return null;
  return (
    <Helmet>
      {blocks.map((block, i) => (
        <script key={i} type="application/ld+json">
          {JSON.stringify(block)}
        </script>
      ))}
    </Helmet>
  );
}
